import { render, staticRenderFns } from "./steps-head.vue?vue&type=template&id=8ca74e26&scoped=true&"
import script from "./steps-head.vue?vue&type=script&lang=js&"
export * from "./steps-head.vue?vue&type=script&lang=js&"
import style0 from "./steps-head.vue?vue&type=style&index=0&id=8ca74e26&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca74e26",
  null
  
)

export default component.exports